module.exports = __webpack_public_path__ + "img/bottom_cow_001.ce8d89f3.svg";